import { CORE_NODES } from '#pplx/frontend/composer-sdk/lexical/nodes/Nodes.js';
// oxlint-disable-next-line pplx/no-internal-imports -- this resolver intentionally consumes the capability registry directly.
import { CAPABILITY_NODES } from '#pplx/frontend/composer-sdk/plugins/internal/capabilities/capabilityNodes.js';
/**
 * Resolves the full set of Lexical node classes needed to register on a
 * composer editor's `initialConfig.nodes`, given the plugins mounted on the
 * surface. Unions `CORE_NODES` with the nodes each plugin's declared
 * capabilities contribute via `CAPABILITY_NODES`, deduplicating so no node
 * class appears twice (Lexical rejects duplicate registration).
 *
 * @example
 * const plugins = [askLinkPlugin()];
 * const nodes = resolveNodesForPlugins(plugins);
 * // nodes contains CORE_NODES + LINK_CAPABILITY_NODES, no duplicates
 */
export function resolveNodesForPlugins(plugins) {
    const capabilityNodes = plugins.flatMap((plugin) => plugin.capabilities.flatMap((capability) => CAPABILITY_NODES[capability.kind] ?? []));
    return Array.from(new Set([...CORE_NODES, ...capabilityNodes]));
}
//# sourceMappingURL=resolveNodesForPlugins.js.map